import { groupDigits, parseDollars } from "./money.js"

// What the field may re-group mid-keystroke. Anything holding a decimal point
// or an m/k suffix is left exactly as typed until the user leaves the field —
// stripping non-digits on every input event is what used to turn "2.6m" into
// "26" before TradeMachine.Money ever saw it (#488).
const PLAIN_DIGITS = /^[\d,]*$/

export default {
  mounted() {
    this.format()
    this.el.addEventListener("keydown", (e) => this.handleKeydown(e))
    this.el.addEventListener("input", () => this.handleInput())
    this.el.addEventListener("focus", () => this.el.select())
    this.el.addEventListener("blur", () => this.format())
  },
  updated() {
    if (this.el !== document.activeElement) this.format()
  },
  // Resolves whatever is in the field to whole dollars and shows it grouped, so
  // "2.6m" reads back as "2,600,000" once the user leaves the field. Input the
  // server would reject is left untouched for its own fallback to handle.
  format() {
    const dollars = parseDollars(this.el.value)
    if (dollars === null) return
    this.el.value = groupDigits(dollars)
  },
  digitsBefore(str, pos) {
    return str.slice(0, pos).replace(/[^0-9]/g, "").length
  },
  posAfterDigit(str, n) {
    if (n <= 0) return 0
    let count = 0
    for (let i = 0; i < str.length; i++) {
      if (/[0-9]/.test(str[i])) {
        count++
        if (count === n) return i + 1
      }
    }
    return str.length
  },
  handleKeydown(e) {
    const el = this.el
    const pos = el.selectionStart
    if (e.key === "Backspace" && pos > 0 && el.value[pos - 1] === ",") {
      el.setSelectionRange(pos - 1, pos - 1)
    } else if (e.key === "Delete" && pos < el.value.length && el.value[pos] === ",") {
      el.setSelectionRange(pos + 1, pos + 1)
    }
  },
  handleInput() {
    const el = this.el
    // Shorthand has to survive keystroke by keystroke: "2.", "2.6" and "2.6m"
    // are all half-typed money, so only plain digit runs get re-grouped here.
    if (!PLAIN_DIGITS.test(el.value)) return
    const pos = el.selectionStart
    const digitPos = this.digitsBefore(el.value, pos)
    const raw = el.value.replace(/[^0-9]/g, "").replace(/^0+(?=\d)/, "")
    if (raw === "") {
      el.value = ""
      return
    }
    const formatted = groupDigits(raw)
    if (el.value === formatted) return
    el.value = formatted
    const newPos = this.posAfterDigit(formatted, digitPos)
    el.setSelectionRange(newPos, newPos)
  }
}
